import * as zod from "zod";

export const simpleUrl = zod.preprocess((value) => {
  if (!value) {
    return value;
  }
  return value.startsWith("http://") || value.startsWith("https://")
    ? value
    : `https://${value}`;
}, zod.string().regex(/^(https?:\/\/)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}\/?$/, {message: 'Please enter a valid URL'}));

export const fullUrl = zod.preprocess((value) => {
  if (!value) {
    return value;
  }
  return value.startsWith('http://') || value.startsWith('https://')
    ? value
    : `https://${value}`;
}, zod.string().regex(/^(https?:\/\/)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}([a-zA-Z0-9\-._~:\/?#[\]@!$&'()*+,;=]*)?$/, { message: 'Please enter a valid URL' }));
